import { multiply, addIndex, forEach, compose, map, prop, equals, head, __ } from 'ramda';
import React from 'react';
import ReactDOM from 'react-dom';
import autoBind from '../../modules/autoBind';
import XTNA from './XTNA';

const colors = {
  border: 'rgb(117, 113, 113)',
  innerSquare: 'rgb(217, 217, 217)',
  red: 'rgb(255, 0, 0)',
  blue: 'rgb(0, 0, 255)',
  black: 'rgb(0, 0, 0)',
  white: 'rgb(255, 255, 255)',
  axis: 'rgb(192, 192, 192)'
};

export default class XTNAChart extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { canvas: null };
  }
  componentDidMount() {
    const canvas = document.createElement('canvas');
    canvas.setAttribute('style', 'width: 100%; height: 100%;');
    canvas.setAttribute('width', canvas.offsetWidth);
    canvas.setAttribute('height', canvas.offsetWidth);
    canvas.setAttribute('id', this.props.id);
    ReactDOM.findDOMNode(this).appendChild(canvas);
    this.setState({ canvas });
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    ReactDOM.findDOMNode(this).removeChild(this.state.canvas);
  }
  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  }
  render() {
    if (this.state.canvas) {
      this.renderCanvas(this.state.canvas);
    }
    
    return <div style={{ marginBottom: '10px' }}></div>;
  }
  renderCanvas(canvas) {
    canvas.setAttribute('width', canvas.offsetWidth);
    canvas.setAttribute('height', canvas.offsetWidth);
    this.width = multiply(canvas.offsetWidth);
    this.height = multiply(canvas.offsetWidth);

    const ctx = canvas.getContext('2d');
    const width = this.width, height = this.height;

    // gray border
    ctx.fillStyle = colors.border;
    ctx.fillRect(0, 0, width(1), height(1));
    ctx.clearRect(width(.05), height(.05), width(.9), height(.9));

    // draw derived properties      
    ctx.fillStyle = colors.red;
    ctx.fillRect(width(.38), 0, width(.07), height(.05));
    ctx.fillRect(width(.38), height(.95), width(.07), height(.05));
    ctx.fillRect(0, height(.38), width(.05), height(.07));
    ctx.fillRect(width(.95), height(.38), width(.05), height(.07));

    ctx.fillStyle = colors.blue;
    ctx.fillRect(width(.55), 0, width(.07), height(.05));
    ctx.fillRect(width(.55), height(.95), width(.07), height(.05));
    ctx.fillRect(0, height(.55), width(.05), height(.07));
    ctx.fillRect(width(.95), height(.55), width(.05), height(.07));

    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = colors.white;
    ctx.font = 'bold 9pt Arial';

    const derivedProperties = XTNA.deriveProperties(this.props);

    ctx.fillText(derivedProperties.NRef, width(.415), height(.025));
    ctx.fillText(derivedProperties.NAcc, width(.415), height(.975));
    ctx.fillText(derivedProperties.NTar, width(.025), height(.415));
    ctx.fillText(derivedProperties.NPer, width(.975), height(.415));

    ctx.fillText(derivedProperties.ARef, width(.585), height(.025));
    ctx.fillText(derivedProperties.AAcc, width(.585), height(.975));
    ctx.fillText(derivedProperties.ATar, width(.025), height(.585));
    ctx.fillText(derivedProperties.APer, width(.975), height(.585));

    // inner gray square
    ctx.fillStyle = colors.innerSquare;
    ctx.fillRect(width(.2), height(.2), width(.6), height(.6));
    ctx.clearRect(width(.34), height(.34), width(.32), height(.32));

    // dashed lines
    ctx.lineWidth = 1;
    ctx.strokeStyle = colors.axis;
    ctx.dashedLine(width(.5), height(.1), width(.5), height(.9), 2);
    ctx.dashedLine(width(.1), height(.5), width(.9), height(.5), 2);

    // draw text
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = colors.white;
    ctx.font = 'bold 11pt Arial';

    const letters = 'NTXA'.split('');
    addIndex(forEach)((letter, index) => {
      const pos = this.getDiagonalPosition(10.5, index);
      ctx.fillText(letter, pos.x, pos.y);
    }, letters);

    ctx.fillStyle = colors.black;
    ctx.font = '7pt Arial';
    ctx.fillText('REFLEXIÓN', width(.5), height(.07));
    ctx.fillText('ACCIÓN', width(.5), height(.93));
    
    const drawVertical = (text, xPos, yPos) => {
      addIndex(forEach)((letter, index) => {
        ctx.fillText(letter, xPos, yPos - text.length*10/2 + 4 + 10*index);
      }, text);
    };
    
    drawVertical('TAREAS', width(.07), height(.5));
    drawVertical('PERSONAS', width(.93), height(.5));

    // draw numbers
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = colors.black;
    ctx.font = '7pt Arial';
    for (let quadrant = 0; quadrant < 4; quadrant++) {
      for (let num = 1; num < 10; num ++) {
        let position = this.getDiagonalPosition(num, quadrant);
        ctx.fillText(num.toString(), position.x, position.y);
      }
    }

    // plot points
    const mapPropToPos = compose(
      addIndex(map)(this.getDiagonalPosition),
      map(prop(__, this.props)));

    const dashLine = ctx.dashedLine.bind(ctx);
    const line = (x1, y1, x2, y2) => {
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
    };

    const drawLines = (positions, color, dashed, offsetX, offsetY) => {
      offsetX = offsetX || 0;
      offsetY = offsetY || 0;
      ctx.fillStyle = color;
      ctx.strokeStyle = color;
      ctx.lineWidth = 3;

      // draw lines
      for (let i = 0; i < 4; i++) {
        const pos1 = positions[i];
        const pos2 = positions[(i+1)%4];
        (dashed ? dashLine : line)(pos1.x + offsetX, pos1.y + offsetY, pos2.x + offsetX, pos2.y + offsetY, 2);
      }
    };

    ctx.font = 'bold 9pt Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = colors.white;
    
    const drawSquares = (positions, properties, color, offsetX, offsetY) => {
      offsetX = offsetX || 0;
      offsetY = offsetY || 0;

      // draw squares
      let i = 0; 
      forEach((pos) => {
        ctx.fillStyle = color;
        ctx.fillRect(pos.x - width(.025) + offsetX, pos.y - height(.025) + offsetY, width(.05), height(.05));
        ctx.fillStyle = colors.white;
        ctx.fillText(this.props[properties[i++]], pos.x + offsetX, pos.y + offsetY);
      }, positions);
    };

    const getPropNames = (type) => XTNA.props().filter(compose(equals(type), head));
    
    const naturalProperties = getPropNames('N');
    const adaptedProperties = getPropNames('A');

    const quadrants = { X: 2, T: 1, N: 0, A: 3 };
    const naturalPositions = mapPropToPos(naturalProperties.sort((a, b) => quadrants[a[1]] - quadrants[b[1]]));
    const adaptedPositions = mapPropToPos(adaptedProperties.sort((a, b) => quadrants[a[1]] - quadrants[b[1]]));

    drawLines(naturalPositions, colors.red, false, 2, -2);
    drawLines(adaptedPositions, colors.blue, true, -2, 2);
    drawSquares(adaptedPositions, adaptedProperties, colors.blue, -2, 2);
    drawSquares(naturalPositions, naturalProperties, colors.red, 2, -2);
  }
  getDiagonalPosition(scale, quadrant) {
    const rightSide = quadrant === 0 || quadrant === 3;
    const upSide = quadrant === 0 || quadrant === 1;

    const zeroOffsetX = this.width(.45)/10*scale * (rightSide ? 1 : -1);
    const zeroOffsetY = this.height(.45)/10*scale * (upSide ? -1 : 1);

    return {
      x: this.width(.5) + zeroOffsetX,
      y: this.height(.5) + zeroOffsetY,
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/xtna/Chart.jsx